import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';
import { FilterChangelogPatch } from '../shared/field_inputs/HelpMethods';

const CancelToken = axios.CancelToken;
let cancel;

export async function HandleAddDeal(deal) {
    const url = 'api/crmDealFront/addDeal/';

    const res = await axios.post(url, deal).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function HandleDeleteDeal(dealId) {
    const url = 'api/crmDealFront/deleteDeal/';
    const query = { dealId: dealId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, deal: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    deal: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                deal: null,
            };
        }
    );
    return response;
}

export async function HandlePatchDeal(initialDeal, newDeal) {
    const patch = jsonpatch.compare(initialDeal, newDeal);
    let changelogPatch = [];

    patch.forEach((operation) => {
        operation.oldValue = jsonpatch.getValueByPointer(initialDeal, operation.path);
    });

    changelogPatch = FilterChangelogPatch(patch);
    
    const url = 'api/crmDealFront/patchDeal/';
    const body = {
        entityId: initialDeal.id,
        serializedPatch: JSON.stringify(patch),
        serializedChangelogPatch: JSON.stringify(changelogPatch),
    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, deal: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    deal: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                deal: null,
            };
        }
    );

    return response;
}

export async function GetDealHistory(dealId, callback) {
    cancel && cancel();

    const uri = `api/crmDealFront/getDealHistory/`;
    const params = {
        dealId: dealId,
    };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetDealsFromOrganization(organizationId, callback) {
    cancel && cancel();

    const uri = `api/crmDealFront/getDealsFromOrganization/`;
    const params = {
        organizationId: organizationId,
    };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                }
                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetDealsFromPerson(personId, callback) {
    cancel && cancel();

    const uri = `api/crmDealFront/getDealsFromPerson/`;
    const params = {
        personId: personId,
    };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                }
                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetActiveDeal(dealId, callback) {
    cancel && cancel();

    const uri = `api/crmDealFront/getDeal/`;
    const params = {
        dealId,
    };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false, data: null });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false, data: null });
    }
}